import { isObject } from '..'

export const getFullName = specialityYear => {
  if (specialityYear) {
    return `${specialityYear.specialityName} (${specialityYear.studyYearName})`
  }

  return 'Without year'
}

export const getFullAbbreviation = specialityYear => {
  if (specialityYear) {
    return `${specialityYear.specialityAbbreviation} (${specialityYear.studyYearName})`
  }

  return 'Without speciality'
}

export const sortBySpecialityAndYear = (a, b) => {
  if (!isObject(a)) {
    return 1
  }
  if (!isObject(b)) {
    return -1
  }

  const abbreviation = a.specialityAbbreviation.localeCompare(b.specialityAbbreviation)
  const studyYearName = a.studyYearName.localeCompare(b.studyYearName)

  return abbreviation || studyYearName
}
